import React from 'react';
import { TopNavbar } from 'ui';

export function PublicNavbar() {
  return <TopNavbar logoVariant="large" />;
}
